import { PayloadAction, createAction } from '@reduxjs/toolkit';

export const frameAgreementState = {
    formData: {
        frameAgreementType: "",
        scrmId: "",
        agreementType: "",
        agreementSubType: "",
        contractualSituation: "",
        caseName: "",
        market: "",
        caseSummary: "",
        coOwners: "",
        agreementTerritory: "",
        agreementIdentification:"",
        deviationSummary: "",
        account1Star: "",
        salesMode: "",
        agreementLink: "",
        attachedFiles: [],
        attachedFilesToDelete: [],
        approvalDetails: [],
        standardDeviation: false,
        accountOptionsList: [],
        selectedAccountInfo: []
    },
    countryList: [],
    frameAgreementTypeList: [],
    agreementTypeList: [],
    agreementSubTypeList: [],
    contractualSituationList: [],
    isProcessing: false,
    isLoaded: false,
    opportunityData: null,
    hasScrmDefaultData: false,
    agreementNotFound: false
}

export const frameAgreementReducers = {
    setFrameAgreementFormData(state: any, action: PayloadAction<any>) {
        state.data.frameAgreement.formData = action.payload;
    },
    setFrameAgreementFormDataByKey(state: any, action: PayloadAction<{ key: string; value: string | object | boolean }>) {
        const { key, value } = action.payload;
        console.log(key, value, "REdux")
        state.data.frameAgreement.formData[key] = value;
    },
    setFrameAgreementProcessingState(state: any, action: PayloadAction<boolean>) {
        state.data.frameAgreement.isProcessing = action.payload;
    },
    setFrameAgreementLoadedState(state: any, action: PayloadAction<boolean>) {
        state.data.frameAgreement.isLoaded = action.payload;
    },
    setFrameAgreementOpportunityData(state: any, action: PayloadAction<any>) {
        state.data.frameAgreement.opportunityData = action.payload;
    },
    setFrameAgreementScrmDefault(state: any, action: PayloadAction<boolean>) {
        state.data.frameAgreement.hasScrmDefaultData = action.payload;
    },
    setFrameAgreementCountryList(state: any, action: PayloadAction<any[]>) {
        state.data.frameAgreement.countryList = action.payload;
    },
    setFrameAgreementNotFound(state: any, action: PayloadAction<boolean>) {
        state.data.frameAgreement.agreementNotFound = action.payload;
    },
    setFrameAgreementDeletedFiles(state: any, action: PayloadAction<any>) {
        const { fileIndex } = action.payload;
        const file = state.data.frameAgreement.formData.attachedFiles[fileIndex];
        if (file) {
            state.data.frameAgreement.formData.attachedFilesToDelete = [
                ...state.data.frameAgreement.formData.attachedFilesToDelete,
                file
            ];
        }
        state.data.frameAgreement.formData.attachedFiles = state.data.frameAgreement.formData.attachedFiles.filter((_, index) => index !== fileIndex);
    },
    setFrameAgreementAttachedFiles(state: any, action: PayloadAction<any[]>) {
        const existingFiles = state.data.frameAgreement.formData.attachedFiles.filter((file) => !file?.file?.size);
        state.data.frameAgreement.formData.attachedFiles = [
            ...existingFiles,
            ...action.payload,
        ]
    },
    setFrameAgreementDropdownList(state: any, action: PayloadAction<{ key: string; value: any[] }>) {
        const { key, value } = action.payload;
        state.data.frameAgreement[key] = value;
    },
}